module.exports = __webpack_public_path__ + "img/H2.0ed64509.png";